// @ts-strict-ignore
import React from 'react'
import { Pagination, RowsPerPageType } from '@node-space/ui-components'
import { Paging } from 'types/types'

interface TransactionsPaginationProps {
  pagination: Paging
  setOffset?: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  nrOfRows: string
  setNrOfRows: React.Dispatch<React.SetStateAction<string>>
}

export const TransactionsPagination = ({
  pagination,
  setOffset,
  page,
  setPage,
  nrOfRows,
  setNrOfRows,
}: TransactionsPaginationProps) => {
  const total = pagination.total || 0
  const rowsPerPage = parseInt(nrOfRows, 10) as RowsPerPageType

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
    const offset = newPage * rowsPerPage
    setOffset(offset)
  }

  const handleChangeRowsPerPage = (newRowsPerPage: RowsPerPageType) => {
    setNrOfRows(newRowsPerPage.toString())
    setPage(0)
    setOffset(0)
  }

  return (
    <Pagination
      testId="transactions-pagination"
      page={page}
      rowsPerPage={rowsPerPage}
      total={total}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
    />
  )
}
